import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  isTeamsLoading: false,
  teams: {},
}

// getters
export const getters = {
  getTeamsForSelectedRound: ({ teams }, getters, { route: { params: { roundId } } }) => teams[roundId] || [],
}
// mutations
export const mutations = {
  fetchTeamsStart(state) {
    state.isTeamsLoading = true
  },
  fetchTeamsSuccess(state, { roundId, teams }) {
    Vue.set(state.teams, roundId, teams)
    state.isTeamsLoading = false
  },
  fetchTeamsFailed(state) {
    state.isTeamsLoading = false
  },
}
// actions
export const actions = {
  async fetchTeams({
    commit,
    dispatch,
    state: { teams },
    rootState: { route: { params: { roundId } } },
  }) {
    if (typeof teams[roundId] !== 'undefined') {
      return teams
    }
    let response = null
    try {
      commit('fetchTeamsStart')
      response = await axios.get(`round/${roundId}/teams`)
      commit('fetchTeamsSuccess', {
        teams: response,
        roundId,
      })
      if (response.length) {
        dispatch('rounds/assignAthleteIntoRound/handleChangeTeam', { teamId: response[0].id }, { root: true })
      }
    } catch (e) {
      commit('fetchTeamsFailed')
    }
    return response
  },
}
